import { ReactNode, useEffect } from 'react'
import { useAppSelector } from '../../redux/hooks'
import { useNavigate } from 'react-router-dom'
import { GenericSpinner } from '../GenericSpinner/GenericSpinner'
import { Wrapper } from '../Wrapper/Wrapper'

interface SecureRouteProps {
    children?: ReactNode
}

export const SecureRoute = ({ children }: SecureRouteProps) => {
  const auth = useAppSelector(state => state.auth)
  const navigate = useNavigate()

  useEffect(() => {
    if (!auth.pending && !auth.data) {
      navigate('/auth/sign-in')
    }
  }, [auth, navigate])

  if (auth.pending) {
    return <GenericSpinner />
  }

  if (!auth.data) {
    return <Wrapper />
  }
  
  return children
}